import { useParams, Link } from 'react-router-dom';
import { useEffect, type FC } from 'react';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SchemaOrg from '@/components/base/SchemaOrg';
import { categories, articles } from '@/mocks/data';

const articleImages: Record<string, string> = {
  'getting-started-guide': 'https://readdy.ai/api/search-image?query=Modern%20digital%20platform%20content%20illustration%20with%20warm%20minimalist%20aesthetic%2C%20soft%20neutral%20background%2C%20clean%20editorial%20layout%2C%20subtle%20geometric%20details&width=400&height=240&seq=cat-article-getting-started-guide&orientation=landscape',
  'platform-overview': 'https://readdy.ai/api/search-image?query=Modern%20digital%20platform%20content%20illustration%20with%20warm%20minimalist%20aesthetic%2C%20soft%20neutral%20background%2C%20clean%20editorial%20layout%2C%20subtle%20geometric%20details&width=400&height=240&seq=cat-article-platform-overview&orientation=landscape',
  'advanced-features-guide': 'https://readdy.ai/api/search-image?query=Modern%20digital%20platform%20content%20illustration%20with%20warm%20minimalist%20aesthetic%2C%20soft%20neutral%20background%2C%20clean%20editorial%20layout%2C%20subtle%20geometric%20details&width=400&height=240&seq=cat-article-advanced-features-guide&orientation=landscape',
  'resource-download-guide': 'https://readdy.ai/api/search-image?query=Modern%20digital%20platform%20content%20illustration%20with%20warm%20minimalist%20aesthetic%2C%20soft%20neutral%20background%2C%20clean%20editorial%20layout%2C%20subtle%20geometric%20details&width=400&height=240&seq=cat-article-resource-download-guide&orientation=landscape',
  'common-questions-answers': 'https://readdy.ai/api/search-image?query=Modern%20digital%20platform%20content%20illustration%20with%20warm%20minimalist%20aesthetic%2C%20soft%20neutral%20background%2C%20clean%20editorial%20layout%2C%20subtle%20geometric%20details&width=400&height=240&seq=cat-article-common-questions-answers&orientation=landscape',
  'security-privacy-guide': 'https://readdy.ai/api/search-image?query=Modern%20digital%20platform%20content%20illustration%20with%20warm%20minimalist%20aesthetic%2C%20soft%20neutral%20background%2C%20clean%20editorial%20layout%2C%20subtle%20geometric%20details&width=400&height=240&seq=cat-article-security-privacy-guide&orientation=landscape',
  'mobile-app-guide': 'https://readdy.ai/api/search-image?query=Modern%20digital%20platform%20content%20illustration%20with%20warm%20minimalist%20aesthetic%2C%20soft%20neutral%20background%2C%20clean%20editorial%20layout%2C%20subtle%20geometric%20details&width=400&height=240&seq=cat-article-mobile-app-guide&orientation=landscape',
  'team-collaboration-best-practices': 'https://readdy.ai/api/search-image?query=Modern%20digital%20platform%20content%20illustration%20with%20warm%20minimalist%20aesthetic%2C%20soft%20neutral%20background%2C%20clean%20editorial%20layout%2C%20subtle%20geometric%20details&width=400&height=240&seq=cat-article-team-collaboration-best-practices&orientation=landscape',
};

const detailImages: Record<string, string> = {
  'getting-started-guide': 'https://readdy.ai/api/search-image?query=Professional%20editorial%20content%20illustration%20with%20warm%20minimalist%20modern%20design%2C%20clean%20digital%20platform%20aesthetic%2C%20soft%20neutral%20background%2C%20subtle%20geometric%20elements%2C%20magazine%20quality%20photography&width=1200&height=600&seq=detail-getting-started-guide&orientation=landscape',
  'platform-overview': 'https://readdy.ai/api/search-image?query=Professional%20editorial%20content%20illustration%20with%20warm%20minimalist%20modern%20design%2C%20clean%20digital%20platform%20aesthetic%2C%20soft%20neutral%20background%2C%20subtle%20geometric%20elements%2C%20magazine%20quality%20photography&width=1200&height=600&seq=detail-platform-overview&orientation=landscape',
  'advanced-features-guide': 'https://readdy.ai/api/search-image?query=Professional%20editorial%20content%20illustration%20with%20warm%20minimalist%20modern%20design%2C%20clean%20digital%20platform%20aesthetic%2C%20soft%20neutral%20background%2C%20subtle%20geometric%20elements%2C%20magazine%20quality%20photography&width=1200&height=600&seq=detail-advanced-features-guide&orientation=landscape',
  'resource-download-guide': 'https://readdy.ai/api/search-image?query=Professional%20editorial%20content%20illustration%20with%20warm%20minimalist%20modern%20design%2C%20clean%20digital%20platform%20aesthetic%2C%20soft%20neutral%20background%2C%20subtle%20geometric%20elements%2C%20magazine%20quality%20photography&width=1200&height=600&seq=detail-resource-download-guide&orientation=landscape',
  'common-questions-answers': 'https://readdy.ai/api/search-image?query=Professional%20editorial%20content%20illustration%20with%20warm%20minimalist%20modern%20design%2C%20clean%20digital%20platform%20aesthetic%2C%20soft%20neutral%20background%2C%20subtle%20geometric%20elements%2C%20magazine%20quality%20photography&width=1200&height=600&seq=detail-common-questions-answers&orientation=landscape',
  'security-privacy-guide': 'https://readdy.ai/api/search-image?query=Professional%20editorial%20content%20illustration%20with%20warm%20minimalist%20modern%20design%2C%20clean%20digital%20platform%20aesthetic%2C%20soft%20neutral%20background%2C%20subtle%20geometric%20elements%2C%20magazine%20quality%20photography&width=1200&height=600&seq=detail-security-privacy-guide&orientation=landscape',
  'mobile-app-guide': 'https://readdy.ai/api/search-image?query=Professional%20editorial%20content%20illustration%20with%20warm%20minimalist%20modern%20design%2C%20clean%20digital%20platform%20aesthetic%2C%20soft%20neutral%20background%2C%20subtle%20geometric%20elements%2C%20magazine%20quality%20photography&width=1200&height=600&seq=detail-mobile-app-guide&orientation=landscape',
  'team-collaboration-best-practices': 'https://readdy.ai/api/search-image?query=Professional%20editorial%20content%20illustration%20with%20warm%20minimalist%20modern%20design%2C%20clean%20digital%20platform%20aesthetic%2C%20soft%20neutral%20background%2C%20subtle%20geometric%20elements%2C%20magazine%20quality%20photography&width=1200&height=600&seq=detail-team-collaboration-best-practices&orientation=landscape',
};

const CategoryPage: FC = () => {
  const { slug } = useParams<{ slug: string }>();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [slug]);

  const currentCategory = categories.find((c) => c.slug === slug);
  const categoryArticles = articles.filter((a) => a.category === slug);
  const allCategories = categories;

  if (!currentCategory) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background-50 pt-16">
        <div className="text-center">
          <i className="ri-error-warning-line text-4xl text-foreground-400" />
          <p className="mt-4 text-foreground-600">未找到该分类</p>
          <Link to="/" className="mt-4 inline-block text-primary-600 hover:text-primary-700 text-sm font-medium cursor-pointer">
            返回首页
          </Link>
        </div>
      </div>
    );
  }

  const breadcrumbItems = [
    { label: '首页', href: '/' },
    { label: currentCategory.name },
  ];

  return (
    <div className="min-h-screen bg-background-50 pt-16">
      <SchemaOrg
        type="WebPage"
        data={{
          name: `${currentCategory.name} - 17c.com`,
          url: `https://www.17c.com/category/${slug}`,
          description: currentCategory.description,
          inLanguage: 'zh-Hans',
        }}
      />

      <div className="bg-background-100 border-b border-background-200/70">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-8 md:py-12">
          <div className="mb-4">
            <Breadcrumb items={breadcrumbItems} />
          </div>
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-50 text-accent-600">
              <i className={`${currentCategory.icon} text-lg`} />
            </div>
            <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
              {currentCategory.name}
            </h1>
          </div>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl">
            {currentCategory.description}
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex gap-6">
          <aside className="hidden lg:block w-56 flex-shrink-0">
            <nav aria-label="分类导航" className="sticky top-24">
              <h4 className="text-sm font-semibold text-foreground-950 mb-3 font-label">全部分类</h4>
              <ul className="space-y-1">
                {allCategories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className={`block px-3 py-2.5 rounded-md text-sm transition-colors duration-200 cursor-pointer ${
                        cat.slug === slug
                          ? 'bg-primary-50 text-primary-600 font-medium'
                          : 'text-foreground-600 hover:bg-background-100 hover:text-foreground-900'
                      }`}
                    >
                      <span className="flex items-center gap-2">
                        <i className={`${cat.icon} text-base`} />
                        {cat.name}
                      </span>
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          </aside>

          <div className="flex-1 min-w-0">
            <div className="lg:hidden mb-6">
              <div className="flex gap-2 overflow-x-auto pb-2">
                {allCategories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className={`flex-shrink-0 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors duration-200 cursor-pointer ${
                      cat.slug === slug
                        ? 'bg-primary-500 text-background-50'
                        : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                    }`}
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            {categoryArticles.length > 0 ? (
              <div className="space-y-5">
                {categoryArticles.map((article) => (
                  <Link
                    key={article.slug}
                    to={`/article/${article.slug}`}
                    className="group flex flex-col sm:flex-row gap-4 md:gap-6 p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
                  >
                    <div className="relative w-full sm:w-56 md:w-64 h-40 sm:h-36 flex-shrink-0 rounded-md overflow-hidden">
                      <img
                        src={articleImages[article.slug] || articleImages['getting-started-guide']}
                        alt={article.title}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                    <div className="flex-1 flex flex-col">
                      <div className="flex items-center gap-3 mb-2 flex-wrap">
                        <span className="text-xs text-foreground-500">{article.date}</span>
                        <span className="text-xs text-accent-600 bg-accent-50 px-2 py-0.5 rounded-full font-medium">
                          {article.readTime}
                        </span>
                      </div>
                      <h3 className="text-base md:text-lg font-semibold text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors">
                        {article.title}
                      </h3>
                      <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
                        {article.excerpt}
                      </p>
                      <div className="mt-auto pt-3 flex flex-wrap gap-1.5">
                        {article.tags.map((tag) => (
                          <span key={tag} className="text-xs text-foreground-500 bg-background-100 px-2 py-0.5 rounded">
                            {tag}
                          </span>
                        ))}
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-background-100 text-foreground-400">
                  <i className="ri-file-list-3-line text-2xl" />
                </div>
                <h3 className="mt-4 text-foreground-700 font-medium">暂无相关文章</h3>
                <p className="mt-1 text-sm text-foreground-500">该分类下暂时还没有文章，请浏览其他分类</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryPage;